import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { EvidenceSection } from './components/EvidenceSection';
import { TraditionalMethodsSection } from './components/TraditionalMethodsSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ConsequencesSection } from './components/ConsequencesSection';
import { OfferSection } from './components/OfferSection';
import { DeadlineSection } from './components/DeadlineSection';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="w-full font-sans bg-[#faf7f2]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <EvidenceSection data-id="element-3" />
      <TraditionalMethodsSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <ConsequencesSection data-id="element-7" />
      <OfferSection data-id="element-8" />
      <DeadlineSection data-id="element-9" />
      <FloatingCTA data-id="element-10" />
    </div>;
}